module.exports = __webpack_public_path__ + "static/img/antools_app_icon36467.d6d077e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antools_app_icon36467.svg
// module id = VJE2
// module chunks = 1